export const selectTrailRouteName = 'student.trail.select';
export const selectModulesRouteName = "student.module.select";
export const studyNowRouteName = "student.cycle.show";
export const calendarRouteName = "student.calendar.index";
export const homeRouteName = "student.home";
export const showModuleRouteName = "student.module.show";
export const pendingPlanRouteName = "student.plan.pending_confirmation";
